import { Trash } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

export default function ConsumptionTable({ consumption, onDelete }) {
  return (
    <div className="border rounded-md">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Fecha</TableHead>
            <TableHead>Artículo</TableHead>
            <TableHead className="text-right">Cantidad</TableHead>
            <TableHead></TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {consumption.length === 0 ? (
            <TableRow>
              <TableCell colSpan={4} className="text-center text-slate-500 py-8">
                No hay consumos registrados
              </TableCell>
            </TableRow>
          ) : (
            consumption.map((item) => (
              <TableRow key={item.id} className="table-row">
                <TableCell>{item.fecha}</TableCell>
                <TableCell className="font-medium">{item.articulo}</TableCell>
                <TableCell className="text-right">{item.cantidad}</TableCell>
                <TableCell>
                  <Button
                    data-testid={`delete-consumption-${item.id}`}
                    variant="ghost"
                    size="sm"
                    onClick={() => onDelete(item.id)}
                    className="text-red-600 hover:text-red-700 hover:bg-red-50"
                  >
                    <Trash size={16} />
                  </Button>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
